import React, { useEffect, useState } from "react";

import { Table, Button, Space, Badge, Divider } from "antd";
import { Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { tickets_id } from "../../Redux/actions";
import { baseUrl } from "../../Controllers/rest_api_config";
import Axios from "axios";
import { gql, useQuery } from "@apollo/client";
import { toast } from "react-toastify";
import moment from "jalali-moment";

const TicketsTable = ({ data, loading, count, setPage, page }) => {
  const lang_choiced = useSelector((state) => state.lang_change);
  const [filteredInfo, setFilteredInfo] = useState("");
  const [sortedInfo, setSortedInfo] = useState("");

  // const { data, isLoading } = useFetch("tickets_list", "get", "/tickets");

  // const [loading, setLoading] = useState(loading);
  const dispatch = useDispatch();

  // console.log(tableData , "is tableData")
  // var patt1 = /[0-9]/g;
  // var result = window.location.hash.match(patt1);

  const handleChange = (pagination, filters, sorter) => {
    // console.log("Various parameters", pagination, filters, sorter);

    setFilteredInfo(filters);
    setSortedInfo(sorter);

    setPage(pagination.current);

    // // Get New DATA
    // setLoading(true);
  };

  const cat = (categorie) => {
    switch (categorie) {
      case "administrative":
        return lang_choiced.pages.tickets.table.categories.selectors[1];
      case "support":
        return lang_choiced.pages.tickets.table.categories.selectors[0];
      case "financial":
        return lang_choiced.pages.tickets.table.categories.selectors[2];
      default:
        return lang_choiced.pages.tickets.table.categories.selectors[0];
    }
  };
  const status = (status) => {
    switch (status) {
      case "open":
        return <Badge status="success" text={lang_choiced.pages.tickets.ticket.header.status.selectors[0]} />;
      case "closed":
        return <Badge status="error" text={lang_choiced.pages.tickets.ticket.header.status.selectors[1]} />;
      case "answered":
        return <Badge status="processing" text={lang_choiced.pages.tickets.ticket.header.status.selectors[2]} />;
      default:
        return <Badge status="warning" text={lang_choiced.pages.tickets.ticket.header.status.selectors[3]} />;
    }
  };
  const date = (date) => {
    let newDate = new Date(parseInt(date));
    return window.document.documentElement.lang === "fa" ? moment(newDate).locale("fa").format("jYYYY/jMM/jDD HH:mm") : moment(newDate).locale("en").format("YYYY/MM/DD HH:mm");
  };

  const columns = [
    {
      title: lang_choiced.pages.tickets.table.title,
      dataIndex: "title",
      key: "title",
      // ellipsis: true,
      render: (text, record, index) => {
        // console.log(index, record);
        return (
          <Link
            to={{
              pathname: `tickets/${record.ticket_id}`,

              state: {
                ticket: record.ticket_id,
              },
            }}
          >
            <Button type="link">{text}</Button>
          </Link>
        );
      },
    },
    {
      title:  lang_choiced.pages.tickets.table.date_time,
      dataIndex: "created",
      key: "created",
      // sorter: (a, b) => parseInt(a.created) - parseInt(b.created),
      // sortOrder: sortedInfo.columnKey === "created" && sortedInfo.order,
      ellipsis: true,
      render: (text) => {
        return date(text);
      },
    },
    {
      title:  lang_choiced.pages.tickets.table.status,
      dataIndex: "status",
      key: "status",
      // filters: [
      //   { text: "باز", value: "open" },
      //   { text: "بسته شده", value: "closed" },
      //   { text: "پاسخ داده", value: "answered" },
      // ],
      // filteredValue: filteredInfo.status || null,
      // onFilter: (value, record) => record.status.includes(value),

      ellipsis: true,
      render: (text) => {
        return status(text);
      },
    },
    {
      title:  lang_choiced.pages.tickets.table.categories.title,
      dataIndex: "categorie",
      key: "categorie",
      ellipsis: true,
      render: (text) => {
        return cat(text);
      },
    },
  ];
  return (
    <Table
      locale={{ filterConfirm: "تایید", filterReset: "بازیابی" }}
      columns={columns}
      dataSource={data}
      rowKey={(record) => record.created}
      onChange={handleChange}
      pagination={{
        total: count,
        pageSize: 10,
        current: page ? page : 1,
        // pageSizeOptions: [],
      }}
      scroll={{ x: 700 }}
      loading={loading}
    />
  );
};

export default React.memo(TicketsTable);
